<template lang="html">

  <div class="slider-view" v-if="!!$t(`slider_proceso.${$route.name}`)">

    <router-link :to="$t(`enlaces.${$t(`slider_proceso.${$route.name}.padre`)}`)+'#'+$t(`slider_proceso.${$route.name}.id`)" class="cerrar">✕</router-link>

    <slick ref="slick" :options="slickOptions" @beforeChange="handleBeforeChange" class="slider-proceso" v-if="!!$t(`slider_proceso.${$route.name}.pasos`)">

      <template v-for="(el,key) in $t(`slider_proceso.${$route.name}.pasos`)">

        <section class="slide-full-view row-start" :data="`${$route.name}-${key}`">
          <div class="contenedor-texto">
            <h2 class="title" v-html="el.titulo"></h2>
            <div class="cuerpo" v-html="el.cuerpo"></div>
          </div>
        </section>

      </template>

      <section class="slide-full-view column-center" :data="`${$route.name}-final`">
        <div class="contenedor-boton">
          <router-link class="btn" :to="$t(`enlaces.${$route.name.split('_')[1]}`)">
            <span>{{$t(`slider_proceso.${$route.name}.boton`)}}</span>
          </router-link>
        </div>
      </section>

    </slick>

    <h3 class="diapositiva row-center">
      <span class="title -xs">{{actual}} / {{total}}</span>
    </h3>

  </div>

</template>

<script lang="js">

  import Slick from 'vue-slick';

  import {mapGetters,mapActions} from 'vuex';

  import router from '@/router'

  export default  {
    name: 'proceso-vino',
    components: { Slick },
    mounted(){
      if(!!this.getTexts.slider_proceso[this.$route.name]){
        this.total = Object.values(this.getTexts.slider_proceso[this.$route.name].pasos).length+1;
      }else{
        router.push("/");
      }

    },
    data() {
      return {
        slickOptions: {
          slidesToShow: 1,
          infinite : true
        },
        total : 0,
        actual : 1
      }
    },
    computed : {
      ...mapGetters(['getTexts'])
    },
    methods : {

      handleBeforeChange(event, slick, currentSlide, nextSlide) {
        this.actual = nextSlide + 1;
      },
    }
  }
</script>

<style scoped lang="scss">

  @import "@/assets/css/colors.scss";

  .slider-view{
    background: $mud-brown;
  }

  [data=proceso_azafran-cosecha]{
    background: url("/static/img/procesos/azafran/cosecha.jpg") center/cover no-repeat;
  }
  [data=proceso_azafran-recoleccion]{
    background: url("/static/img/procesos/azafran/recoleccion.jpg") center/cover no-repeat;
  }
  [data=proceso_azafran-monda]{
    background: url("/static/img/procesos/azafran/monda.jpg") center/cover no-repeat;
  }
  [data=proceso_azafran-tostado]{
    background: url("/static/img/procesos/azafran/tostado.jpg") center/cover no-repeat;
  }
  [data=proceso_azafran-almacenamiento]{
    background: url("/static/img/procesos/azafran/almacenamiento.jpg") center/cover no-repeat;
  }
  [data=proceso_azafran-final]{
    background: url("/static/img/procesos/azafran/fin.jpg") center/cover no-repeat;
  }

  [data=proceso_vino-vendimia]{
    background: url("/static/img/procesos/vino/vendimia.jpg") center/cover no-repeat;
  }
  [data=proceso_vino-fermentacion]{
    background: url("/static/img/procesos/vino/fermentacion.jpg") center/cover no-repeat;
  }
  [data=proceso_vino-crianza]{
    background: url("/static/img/procesos/vino/crianza.jpg") center/cover no-repeat;
  }
  [data=proceso_vino-etiquetado]{
    background: url("/static/img/procesos/vino/etiquetado.jpg") center/cover no-repeat;
  }
  [data=proceso_vino-final]{
    background: url("/static/img/procesos/vino/fin.jpg") center/cover no-repeat;
  }

  [data=proceso_cava-vendimia]{
    background: url("/static/img/procesos/cava/vendimia.jpg") center/cover no-repeat;
  }
  [data=proceso_cava-tiraje]{
    background: url("/static/img/procesos/cava/tiraje.jpg") center/cover no-repeat;
  }
  [data=proceso_cava-deguelle]{
    background: url("/static/img/procesos/cava/deguelle.jpg") center/cover no-repeat;
  }
  [data=proceso_cava-etiquetado]{
    background: url("/static/img/procesos/cava/etiquetado.jpg") center/cover no-repeat;
  }
  [data=proceso_cava-final]{
    background: url("/static/img/procesos/cava/fin.jpg") center/cover no-repeat;
  }



  [data=proceso_aceite-cosecha]{
    background: url("/static/img/procesos/aceite/cosecha.jpg") center/cover no-repeat;
  }
  [data=proceso_aceite-recepcion]{
    background: url("/static/img/procesos/aceite/recepcion.jpg") center/cover no-repeat;
  }
  [data=proceso_aceite-molienda]{
    background: url("/static/img/procesos/aceite/molienda.jpg") center/cover no-repeat;
  }
  [data=proceso_aceite-extraccion]{
    background: url("/static/img/procesos/aceite/extraccion.jpg") center/cover no-repeat;
  }
  [data=proceso_aceite-almacenamiento]{
    background: url("/static/img/procesos/aceite/almacenamiento.jpg") center/cover no-repeat;
  }
  [data=proceso_aceite-final]{
    background: url("/static/img/procesos/aceite/fin.jpg") center/cover no-repeat;
  }

  [data=proceso_queso-Ordeño]{
    background: url("/static/img/background-proceso.png") center/cover no-repeat;
  }
  [data=proceso_queso-moldelado]{
    background: url("/static/img/background-moldelado.png") center/cover no-repeat;
  }
  [data=proceso_queso-maduracion]{
    background: url("/static/img/background-maduracion.png") center/cover no-repeat;
  }
  [data=proceso_queso-final]{
    background: url("/static/img/banner-queso.jpg") center/cover no-repeat;
  }
  
  
//[data=proceso_queso-final]{
 //   background: url("/static/img/procesos/aceite/fin.jpg") center/cover no-repeat;
  //}

  .contenedor-texto{
    position: relative;
    transform: translateX(-600px);
    opacity: 0;
    transition: .5s;
    transition-delay: .5s;
        pointer-events: none;
    
    .cuerpo{
      text-align: center;
    }
  }

  .contenedor-boton{
    padding: 50px;
    background: $plum;
    width: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, 100vh) scale(.7);

  }

  .slick-active{
    .contenedor-texto{
      transform: translateX(0);
      opacity: 1;
      pointer-events: visible;
    }

    .contenedor-boton{
      transform: translate(-50%, -50%);   
      transition: 1s;
      transition-delay: .5s;
    }
  }

  @media screen and (max-width: 700px){
    .contenedor-texto{
      padding: 25px 25px;
      min-height: 0;
      p{
        font-size: 14px;
      }
    }
  }

    @media screen and (max-height: 720px){
      [data="proceso_aceite-extraccion"] .contenedor-texto{
        max-width:calc(100% - 100px);
      }
    }


</style>



// WEBPACK FOOTER //
// src/components/views/proceso.vue